interface LeftGroupProps {
  children: React.ReactNode;
}

const LeftGroup = ({ children }: LeftGroupProps) => <div>{children}</div>;

export default LeftGroup;
